$(document).ready(function(){
 // const desktopTables = $('.specifications--container').find('.hide_in_mobile');
 // const mobileTables = $('.specifications--container').find('.hide_in_desktop');
  const tables = $('.specifications--container').find('.specs__table');
  $('.responsiveTabs').responsiveTabs({
    startCollapsed: false,
  });
  $(tables).each(function(){
     if($(this).find('tr').length === 0){
        $(this).parents('.one-half.column').hide();
     }
  })  
});

$(document).on('shopify:section:load',function(){
  $('.responsiveTabs').responsiveTabs({
    startCollapsed: false,
  });  
})